import React, { useState, useEffect, CSSProperties } from "react";
import "../styles/home.css";
import Sidebar from "./Sidebar";
import logo2 from "../logo31.png";
import bannerImage from "../banner-image.png";
import Typical from "react-typical";
import { css } from "@emotion/react";
import PacmanLoader from "react-spinners/PacmanLoader";
import { Player, Controls } from "@lottiefiles/react-lottie-player";

const override: CSSProperties = {
	display: "block",
	margin: "0 auto",
	borderColor: "red",
	marginTop: "21rem",
};

function Home() {
	// const [isLoading,setIsLoading] = useState(true);
	let [loading, setLoading] = useState(true);

	useEffect(() => {
		setTimeout(() => {
			setLoading(false);
		}, 1200);
	});
	return (
		<div className="Home">
			{loading ? (
				<PacmanLoader
					color={"#feb800"}
					loading={true}
					cssOverride={override}
					size={25}
				/>
			) : (
				<div className="content">
					<div className="left">
						<h1 className="h1">Hi,</h1>
						<h1>
							I am
							<img src={logo2} alt="logo" />
							ayant
							<br />a{" "}
							<Typical
								steps={[
									"Web Developer🕸️",
									1800,
									"JavaScript Expert🧑‍💻",
									1800,
									"College Student🏫",
									1800,
									"Gamer🎮",
									1200,
								]}
								loop={Infinity}
								wrapper="b"
								className="typical"
							/>
						</h1>
						<h2> Frontend Developer / JavaScript Expert / Designer</h2>

						<a
							href="https://drive.google.com/file/d/1cssit35mzkZdIyvUeuezs3LpkGokh3gW/view?usp=sharing"
							className="btn"
							target="_blank"
							rel="noreferrer"
						>
							Download CV
						</a>
					</div>
					<div className="right">
						{/* <LottiePlayer src="https://assets3.lottiefiles.com/private_files/lf30_WdTEui.json"  background="transparent"  speed="0.5"  style="width: 300px; height: 300px;"  loop controls autoplay></LottiePlayer>  */}
						<Player
							autoplay
							loop
							speed="0.4"
							src="https://assets3.lottiefiles.com/private_files/lf30_WdTEui.json"
							className="developer"
						>
							{/* <Controls visible={true} buttons={['play', 'repeat', 'frame', 'debug']} /> */}
						</Player>

						{/* <img src={bannerImage} alt="banner"/> */}
					</div>
				</div>
			)}
		</div>
	);
}

export default Home;
